export function Disposable(constructor) {
    return class extends constructor {
        constructor(...args) {
            super(...args);
            this._is_disposed = false;
            return new Proxy(this, {
                get: (target, prop) => {
                    if (this._is_disposed) {
                        // We want to allow users to dispose an object multiple times since it would leave you with the desired state anyway
                        if (prop === 'dispose') {
                            return () => { };
                        }
                        throw new Error(`Attempt to access disposed object. Property: ${String(prop)}`);
                    }
                    return target[prop];
                }
            });
        }
        dispose() {
            if (!this._is_disposed) {
                super.dispose();
                this._is_disposed = true;
            }
        }
    };
}
//# sourceMappingURL=Disposable.js.map